import React, { useState, useEffect, useContext } from 'react';
import { styled, alpha } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import InputBase from '@mui/material/InputBase';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

import { OptionsContext } from '../../contexts/OptionsContext';

import TagForm from '../CMSForm/TagForm';

import './ManageFacilities.css';

function ManageTags() {
  const { getTags, tags, deleteTag } = useContext(OptionsContext)
  const [hidden, setHidden] = useState(false)
  const [filteredData, setFilteredData] = useState([])
  const [editFormData, setEditFormData] = useState({})


  function toggleForm() {
    setHidden(!hidden)
  }

  useEffect(() => {
    getTags()
  }, [])


  useEffect(() => {
    console.log(tags)
    console.log(processData(tags))
    setFilteredData([...processData(tags)])
  }, [tags])

  function processData(data) {
    const newData = data.map(e => createData(e.name, e.create_date))
    return newData
  }

  function createData(name, create_date) {
    return { name, create_date };
  }


  function handleCreateNew() {
    setEditFormData({})
    toggleForm()
  }

  function handleEditClick(i) {
    let selected = getCurrListData(i)
    setEditFormData({ ...selected })
    toggleForm()
  }

  function getCurrListData(i) {
    return tags[i]
  }

  function handleDeleteClick(i) {
    let selected = getCurrListData(i)
    const confirm = window.confirm('Are you sure you want to delete this blog?')
    if (confirm) {
      deleteTag(selected._id)
    }
  }

  return (
    <div>
      <Box sx={{ flexGrow: 1 }}>
        <AppBar style={{ backgroundColor: 'white' }} position="static">
          <Toolbar style={{ display: 'flex', justifyContent: 'space-between' }} >

            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Button onClick={handleCreateNew} variant="contained">Create New</Button>
            </div>
          </Toolbar>
        </AppBar>
      </Box>

      {/* form */}
      {hidden && <TagForm
        initialData={editFormData}
        closeForm={() => { toggleForm() }}
      />}


      <TableContainer style={{ marginTop: '30px' }} component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Posted Date</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData.map((row, i) => (
              <TableRow
                key={row.name + i}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell>{row.name}</TableCell>
                <TableCell>{new Date(row.create_date).toLocaleDateString()}</TableCell>
                <TableCell>
                  <div style={{ display: 'flex', justifyContent: 'center' }}>

                    <TableOption
                      color={'primary'}
                      name={'Edit'}
                      onClick={() => { handleEditClick(i) }}
                    >
                      <EditIcon />
                    </TableOption>

                    <TableOption
                      color={'primary'}
                      name={'Delete'}
                      onClick={() => { handleDeleteClick(i) }}
                    >
                      <DeleteIcon />
                    </TableOption>

                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  )
}

export default ManageTags;

const TableOption = ({ children, name, color, onClick }) => {
  return (
    <div style={{ margin: '0px 10px', cursor: 'pointer' }} onClick={onClick}>
      <Tooltip title={name}>
        <IconButton color={color}>
          {children}
        </IconButton>
      </Tooltip>
    </div>
  )
}